module.exports = __webpack_public_path__ + "img/68.182501bc.jpg";